import Axios from 'axios'
import { runtimeConfig } from '../../runtime-config'

export const directoryApiClient = Axios.create({
  baseURL: runtimeConfig.directoryApiToco
})
